module.exports = __webpack_public_path__ + "/2aa6edf8f296a43b32df35f330b7c81c.ttf";